import { makeAutoObservable } from 'mobx';
import { smsSentStatusEnum } from './types';

export interface IIntakeDataStore {
  smsSentStatus: smsSentStatusEnum;
  phoneNumber: string;
  updateSMSStatus(status: smsSentStatusEnum): void;
  updatePhoneNumber(phoneNumber: string): void;
}

export class IntakeDataStore implements IIntakeDataStore {
  smsSentStatus = smsSentStatusEnum.initial;
  phoneNumber = '';

  constructor() {
    makeAutoObservable(this);
  }

  updateSMSStatus(status: smsSentStatusEnum) {
    this.smsSentStatus = status;
  }

  updatePhoneNumber(phoneNumber: string) {
    this.phoneNumber = phoneNumber;
  }
}
